import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
import { useEffect, useRef } from 'react';
import { createInlineMarkupRegistry, EditableText } from '@/components/block-primitives';
import CaretPlaceholder from '../caret-placeholder';
type TitleFieldProps = {
  autoFocus?: boolean;
  editable?: boolean;
  label: string;
  onEnter?: () => void;
  onSubmit: (next: string) => void;
  value?: string;
};
const TitleField = t0 => {
  const $ = _c(10);
  const {
    autoFocus,
    editable: t1,
    label,
    onEnter,
    onSubmit,
    value
  } = t0;
  const editable = t1 === undefined ? false : t1;
  const editorRef = useRef(null);
  let t2;
  let t3;
  if ($[0] !== autoFocus || $[1] !== editable) {
    t2 = () => {
      if (!autoFocus || !editable) {
        return;
      }
      const frame = requestAnimationFrame(() => editorRef.current?.focus());
      return () => cancelAnimationFrame(frame);
    };
    t3 = [autoFocus, editable];
    $[0] = autoFocus;
    $[1] = editable;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  if ($[4] !== editable || $[5] !== label || $[6] !== onEnter || $[7] !== onSubmit || $[8] !== value) {
    t4 = <div className="mb-4">{editable || value ? <CaretPlaceholder className="relative" overlayClassName="text-heading-5 text-quaternary" text={UNTITLED}><EditableText as="div" className={cx("min-h-6 text-heading-5 before:content-none!", value ? "text-primary" : "opacity-100!")} editable={editable} editOnFocus={true} label={label} onEnter={onEnter} onSubmit={onSubmit} optional={true} placeholder={UNTITLED} registry={emptyMarkup} ref={editorRef} singleLine={true} value={value ?? ""} /></CaretPlaceholder> : <p className="text-heading-5 text-quaternary">{UNTITLED}</p>}</div>;
    $[4] = editable;
    $[5] = label;
    $[6] = onEnter;
    $[7] = onSubmit;
    $[8] = value;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
const emptyMarkup = createInlineMarkupRegistry([]);
const UNTITLED = 'Untitled';
export default TitleField;